<template>
    <div>
        <v-card color="#EFEFEF" outlined class="rounded-0 mb-3 mx-2 card-clickeable"
            v-for="item in itemsInternos" :key="item.id" @click="alternarLectura(item, $event)">
            <v-row class="d-flex flex-row">
                <v-col cols="12" md="3" class="ma-0 pa-6">
                    <div class="d-flex flex-column justify-center">
                        <v-img :src="getDiaImgSrc(item)"></v-img>
                    </div>
                </v-col>
                <v-col cols="12" md="9" class="py0">
                    <v-card-subtitle class="font-weight-bold text-body-2 px-3 pb-0 pt-3">
                        {{ item.fecha_formateada }}
                    </v-card-subtitle>
                    <v-card-title class="font-weight-bold text-h6 py-1 px-3" style="word-break: keep-all;">
                        {{ limpiarHtml(item.dia_titulo) }}
                    </v-card-title>
                    <v-card-text class="px-3 py-0">
                        <div v-if="!item.show"
                            class="font-weight-regular black--text text-body-2 my-2 texto-colapsado"
                            v-html="replaceIcons(item.dia_texto)">
                        </div>
                        <v-expand-transition>
                            <div v-show="item.show"
                                class="font-weight-regular black--text text-body-2 my-2">
                                <div v-html="replaceIcons(item.dia_texto)"></div>
                            </div>
                        </v-expand-transition>
                    </v-card-text>
                    <v-card-actions class="d-flex flex-column justify-end align-end py-1 my-0">
                        <!-- .stop es imprescindible: sin el, el click del boton
                             sube hasta el v-card, se ejecutan los dos handlers y
                             el estado queda como estaba. -->
                        <v-btn class="elevation-0 pa-2 text-lowercase" text color="primary"
                            @click.stop="alternarLectura(item)">
                            {{ item.show ? 'Ocultar' : 'seguir leyendo' }}
                            <v-icon v-if="!item.show">mdi-chevron-down</v-icon>
                            <v-icon v-else>mdi-chevron-up</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-col>
            </v-row>
        </v-card>
    </div>
</template>
<script>
export default {
    name: 'ComunicacionesCard',
    props: {
        items: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            itemsInternos: [],
        }
    },
    methods: {

        textoResumido(html) {
            const length = this.$vuetify.breakpoint.xsOnly ? 70 : this.$vuetify.breakpoint.smAndDown ? 100 : this.$vuetify.breakpoint.mdAndDown ? 150 : this.$vuetify.breakpoint.lgAndDown ? 180 : this.$vuetify.breakpoint.xlAndDown ? 200 : 800;
            const textOnly = html.replace(/<[^>]+>/g, ''); // Remueve etiquetas HTML
            return textOnly.length > length
                ? textOnly.substring(0, length) + '...'
                : textOnly;
        },
        limpiarHtml(texto) {
            return texto.replace(/<[^>]*>/g, '');
        },

        /**
         * Abre o cierra una comunicacion. Se comporta como acordeon: al abrir
         * una se cierran todas las demas, asi nunca quedan dos textos largos
         * desplegados peleando por la pantalla.
         *
         * La usan tanto el click en la tarjeta como el boton "seguir leyendo",
         * para que los dos caminos hagan exactamente lo mismo.
         */
        alternarLectura(item, evento) {
            // El texto viene como HTML y trae enlaces de descarga. Si el click
            // fue sobre uno, se respeta el enlace y no se toca la tarjeta.
            if (evento && evento.target && evento.target.closest('a')) {
                return;
            }

            // Si venia seleccionando texto, el click es para copiar, no para
            // cerrar. Sin esto, marcar un parrafo cierra la comunicacion.
            const seleccion = window.getSelection && window.getSelection().toString();
            if (seleccion) {
                return;
            }

            const seEstaAbriendo = !item.show;

            // Primero se cierran todas y despues se abre la elegida: asi el
            // click sobre la que ya estaba abierta la deja cerrada.
            this.itemsInternos.forEach(otra => {
                otra.show = false;
            });

            item.show = seEstaAbriendo;
        },
        getDiaImgSrc(item) {
            return item.dia_img && item.dia_img.trim() !== ''
                ? item.dia_img
                : require('/src/assets/Logo-01.png');
        },

        /* <a href=\"\" download=\"\" style=\"text-decoration:none; color:#00A0DF; \"><span class=\"glyphicon glyphicon-save\"></span><b>&nbsp;Descargar material</b></a><br> */
        replaceIcons(html) {
            return html
                .replace(
                    /<b>Descargar/g,
                    '<i class="mdi mdi-download" style="color:#009fde; font-size:19px; padding-right:2px; display:inline-block; vertical-align:middle;"></i><b>Descargar'
                );
        }
    },
    watch: {
        items: {
            immediate: true,
            handler(nuevosItems) {
                this.itemsInternos = nuevosItems
                    .map(item => ({
                        ...item,
                        show: false
                    })).sort((b, a) => a.dia_prioridad - b.dia_prioridad);
            }
        }
    },
}
</script>
<style scoped>
/* El texto cortado se desvanece en lugar de terminar de golpe.
   Se usa una mascara y no un degradado encima: la mascara vuelve transparentes
   las letras mismas, asi que funciona sobre cualquier fondo. Pintar una banda
   del color de la tarjeta obligaba a que ese color coincidiera exacto con el
   de atras, y cualquier diferencia se notaba como un parche.
   Si el navegador no soporta mask-image el texto simplemente se corta como
   antes: se degrada sin romper nada. */
.texto-colapsado {
    overflow: hidden;
    max-height: 3.75em;
    -webkit-mask-image: linear-gradient(to bottom, #000 55%, transparent 100%);
    mask-image: linear-gradient(to bottom, #000 55%, transparent 100%);
}

/* La tarjeta responde al click siempre: abierta cierra, cerrada abre. */
.card-clickeable {
    cursor: pointer;
}
</style>